export const shareOptions = [
    { label: 'Shared', value: 'True' },
    { label: 'Unshared', value: 'False' }
]